import { Injectable } from '@angular/core';
import { BankDetailsCollapseFormInterface } from '@zaoblako/shared/modules/client/dtos/bank.details/bank-details-collapse-form.dto';
import { BankDetailsDuplicatesPageInterface } from '@zaoblako/shared/modules/client/dtos/bank.details/bank-details-duplicates-page.dto';
import { BankDetailsDuplicatesQueryInterface } from '@zaoblako/shared/modules/client/dtos/bank.details/bank-details-duplicates-query.dto';
import type { BankDetailsFindInterface } from '@zaoblako/shared/modules/client/dtos/bank.details/bank-details-find.dto';
import { BankDetailsQueryInterface } from '@zaoblako/shared/modules/client/dtos/bank.details/bank-details-query.dto';
import { ExternalUserFindInterface } from '@zaoblako/shared/modules/security/dtos/external-user/external-user-find.dto';
import { ExternalUserFormInterface } from '@zaoblako/shared/modules/security/dtos/external-user/external-user-form.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BasisClientService extends BaseService {
  protected baseUrl = '/basis/client';

  public bankDetailsSearch(queryParams?: BankDetailsQueryInterface): Observable<BankDetailsFindInterface[]> {
    return this.http.get<BankDetailsFindInterface[]>(`${this.baseUrl}/bank-details`, {
      params: this.objectToHttpParams(queryParams)
    });
  }

  public contactPersonCreate(body: ExternalUserFormInterface[]): Observable<ExternalUserFindInterface[]> {
    return this.http.post<ExternalUserFindInterface[]>(`${this.baseUrl}/contact-person`, body);
  }

  public getDuplicates(
    queryParams: BankDetailsDuplicatesQueryInterface
  ): Observable<BankDetailsDuplicatesPageInterface> {
    return this.http.get<BankDetailsDuplicatesPageInterface>(`${this.baseUrl}/bank-details/duplicates`, {
      params: this.objectToHttpParams(queryParams)
    });
  }

  public collapse(id: number, body: BankDetailsCollapseFormInterface): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/bank-details/${id}/collapse`, body);
  }
}
